import { render, staticRenderFns } from "./ReportWindow.vue?vue&type=template&id=2f552ef0&scoped=true&"
import script from "./ReportWindow.vue?vue&type=script&lang=js&"
export * from "./ReportWindow.vue?vue&type=script&lang=js&"
import style0 from "./ReportWindow.vue?vue&type=style&index=0&id=2f552ef0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f552ef0",
  null
  
)

export default component.exports